import { render, staticRenderFns } from "./EndorsmentChart.vue?vue&type=template&id=8ed6ced8&scoped=true"
import script from "./EndorsmentChart.vue?vue&type=script&lang=js"
export * from "./EndorsmentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed6ced8",
  null
  
)

export default component.exports